export default __webpack_public_path__ + "static/3_1-6cd573927aef5ebac91fdcb599f9a558.png";